// Inventory summary shape returned by GET /products/inventory-stats.
export interface InventoryStats {
  totalProducts: number;
  totalUnits: number;      // total stock units on hand (base + variants)
  inventoryValue: number;  // sum of stock * selling price, in rupees
  lowStock: number;        // products with 0 < stock <= threshold (server-defined)
  outOfStock: number;      // products with stock === 0
}

// --- localStorage cache: hydrates the stats cards instantly on cold load and
// lets React Query skip the network call while the value is still fresh. The
// authoritative computation + Redis caching now lives on the backend.
const CACHE_KEY = "inventory_stats_cache_v1";

export interface CachedInventoryStats {
  stats: InventoryStats;
  ts: number; // epoch ms when fetched
}

export const readInventoryStatsCache = (): CachedInventoryStats | null => {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as CachedInventoryStats;
  } catch {
    return null;
  }
};

export const writeInventoryStatsCache = (stats: InventoryStats): void => {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify({ stats, ts: Date.now() }));
  } catch {
    // ignore quota / serialization errors — cache is best-effort
  }
};

// Drop the persisted cache so the next inventory visit refetches from the API.
// Call after any product mutation (add/edit/delete).
export const clearInventoryStatsCache = (): void => {
  try {
    localStorage.removeItem(CACHE_KEY);
  } catch {
    // ignore
  }
};
